import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import GetAppIcon from "@mui/icons-material/GetApp";
import Grid from "@mui/material/Grid";
// import AddIcon from '@mui/icons-material/Add';
import {
  actionDataSelectFeatureRequested,
  actionDataGroupUpdated,
  roomsToRrns,
} from "../../Data";
import BuildingFloorsDisplay from "../../Data/DisplayBuildingFloors";
import BuildingDisplay from "../../Data/DisplayBuilding";
import RoomDisplay from "../../Data/DisplayRoom";
import { actionAppBarFloorsInSearchUpdated } from "../../AppBar";
import { Tooltip } from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CircularProgress from "@mui/material/CircularProgress";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Filters from "../../Data";
import RestroomFilter from "../RestroomFilter";
import { xlsx } from "../../Shared/downloader";

const card_ = (theme) => ({
  width: "100%",
  pointerEvents: "auto",
  marginBottom: "4px",
  "& > .MuiCardActions-root": {
    paddingRight: "0px",
  },
});

const expand_ = (theme) => ({
  padding: "0px",
  transform: "rotate(0deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
});

const expandOpen_ = (theme) => ({
  padding: "0px",
  transform: "rotate(180deg)",
});

const verticalDots_ = (theme) => ({
  padding: "0px",
  borderRadius: "0px",
  width: 20,
  color: "rgba(0, 0, 0, 0.25)",
  "&:hover": {
    color: "rgba(0, 0, 0, 0.55)",
  },
});

const cardActionRoot_ = (theme) => ({
  padding: "2px",
  borderTop: "1px solid rgba(0,0,0,0.1)",
});

const checkbox_ = (theme) => ({
  marginRight: "6px",
});

const lastGrid_ = (theme) => ({
  textAlign: "end",
});

const center_ = (theme) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export default function DataCard({ data, headerType }) {
  const [expanded, setExpanded] = useState(true);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const [toolsExpanded, setToolsExpanded] = useState(false);
  const handleToolToggle = () => {
    setToolsExpanded(!toolsExpanded);
  };

  const [filters, setFilters] = useState([]);

  const addFilter = (attribute, value) => {
    const newFilters = [...filters, { attribute, value }];
    setFilters(newFilters);
  };

  const removeFilter = (attribute, value) => {
    const newFilters = filters.filter(
      (filter) => filter.attribute !== attribute && filter.value !== value,
    );
    setFilters(newFilters);
  };

  const filterRooms = (data = [], filters = []) => {
    return data.filter((item) => {
      // [{'attribute': 'urinal', 'value': '5'}]
      return filters.every((filter) => item[filter.attribute] === filter.value);
    });
  };

  const downloadData = () => {
    xlsx({ name: "Restroom Data", features: filteredData.rooms, raw: true });
  };

  const [filteredData, setFilteredData] = useState(data);

  useEffect(() => {
    const rooms = filterRooms(data.rooms, filters);
    setFilteredData({ ...filteredData, rooms, filters });
  }, [filters, data.rooms]);

  let header;
  if (headerType === "filter") {
    header = (
      <DataCardHeader
        data={filteredData}
        expanded={expanded}
        handleExpandClick={handleExpandClick}
        handleToolToggle={handleToolToggle}
        checkboxVisible={false}
        expandVisible={false}
        optionsVisible={false}
        filterType="filterdown"
        addFilter={addFilter}
        removeFilter={removeFilter}
        downloadData={downloadData}
      />
    );
  } else {
    header = (
      <DataCardHeader
        data={filteredData}
        expanded={expanded}
        handleExpandClick={handleExpandClick}
        handleToolToggle={handleToolToggle}
      />
    );
  }

  return (
    <Card sx={card_} variant="outlined">
      {header}
      <DataCardBody
        data={filteredData}
        expanded={expanded}
        toolsExpanded={toolsExpanded}
      />
    </Card>
  );
}

function DataCardHeader(props) {
  const {
    data,
    expanded,
    handleExpandClick,
    handleToolToggle,
    checkboxVisible = true,
    expandVisible = true,
    optionsVisible = true,
    filterType = "default",
    addFilter,
    removeFilter,
    downloadData,
  } = props;

  const { id, filters, loading, layerVisible, rooms, color } = data;

  const dispatch = useDispatch();
  const onClick = () => {
    handleExpandClick();
  };
  const toolsOnClick = () => {
    handleToolToggle();
  };

  const checkboxClick = () => {
    if (layerVisible) {
      dispatch(actionDataGroupUpdated({ id, layerVisible: false }));
      dispatch(
        actionDataSelectFeatureRequested({
          type: "room",
          data: [],
          layerId: data.colorLayerId,
        }),
      );
    } else {
      dispatch(actionDataGroupUpdated({ id, layerVisible: true }));
      dispatch(
        actionDataSelectFeatureRequested({
          type: "room",
          data: roomsToRrns(rooms),
          layerId: data.colorLayerId,
        }),
      );
    }
  };

  let loadingIcon = (
    <IconButton size="small">
      <CircularProgress size={24} />
    </IconButton>
  );
  let checkboxIcon = checkboxVisible ? (
    <Tooltip title="Toggle Highlight">
      <IconButton
        size="small"
        onClick={checkboxClick}
        sx={checkbox_}
        data-testid="search-result-highlight-btn"
      >
        {layerVisible ? (
          <CheckBoxIcon data-testid="search-result-highlight-checked" />
        ) : (
          <CheckBoxOutlineBlankIcon data-testid="search-result-highlight-not-checked" />
        )}
      </IconButton>
    </Tooltip>
  ) : null;

  let filterComponent = null;

  if (filterType === "default") {
    filterComponent = <Filters filters={filters} id={id} />;
  } else if (filterType === "filterdown") {
    filterComponent = (
      <RestroomFilter
        filters={filters}
        rooms={rooms}
        id={id}
        addFilter={addFilter}
        removeFilter={removeFilter}
      />
    );
  }

  return (
    <>
      <CardActions disableSpacing>
        {/* checkbox */}
        <Grid container>
          {checkboxVisible && (
            <Grid size={{ xs: 1 }} sx={center_}>
              {loading ? loadingIcon : checkboxIcon}
            </Grid>
          )}

          {/* filters */}
          <Grid size={{ xs: checkboxVisible ? 9 : 10 }}>
            {filterComponent}
            <Tooltip title="Download Data">
              <IconButton
                onClick={downloadData}
                aria-label="Download Data"
                size="small"
              >
                <GetAppIcon />
              </IconButton>
            </Tooltip>
          </Grid>

          {/* expand/collapse, more option */}
          <Grid size={{ xs: 2 }} sx={[lastGrid_, center_]}>
            {expandVisible && (
              <Tooltip title="Expand/Collapse">
                <IconButton
                  sx={[expand_, expanded && expandOpen_]}
                  onClick={onClick}
                  aria-expanded={expanded}
                  aria-label="show more"
                  size="small"
                  style={{
                    border: `2px solid ${color}`,
                    backgroundColor: `${color}`,
                  }}
                >
                  <ExpandMoreIcon />
                </IconButton>
              </Tooltip>
            )}
            {optionsVisible && (
              <Tooltip title="Options">
                <IconButton
                  sx={verticalDots_}
                  style={{ visibility: expanded ? "visible" : "hidden" }}
                  onClick={toolsOnClick}
                  aria-label="show more tools"
                  size="small"
                >
                  <MoreVertIcon />
                </IconButton>
              </Tooltip>
            )}
          </Grid>
        </Grid>
      </CardActions>
    </>
  );
}

function DataCardBody({ data, expanded, toolsExpanded }) {
  const { id, rooms, loading, groupBy, sortBy, sortDirection } = data;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      actionDataSelectFeatureRequested({
        type: "room",
        data: roomsToRrns(rooms),
        layerId: data.colorLayerId,
      }),
    );
  }, [data]);

  let dataTable;
  if (groupBy === "building-floor") {
    dataTable = (
      <BuildingFloorsDisplay
        id={id}
        rooms={rooms}
        sortBy={sortBy}
        sortDirection={sortDirection}
      />
    );
  } else if (groupBy === "building-floor-sqft") {
    dataTable = (
      <BuildingDisplay
        id={id}
        rooms={rooms}
        sortBy={sortBy}
        sortDirection={sortDirection}
      />
    );
  } else if (groupBy === "room") {
    dataTable = (
      <RoomDisplay
        id={id}
        rooms={rooms}
        sortBy={sortBy}
        sortDirection={sortDirection}
      />
    );
  } else {
    dataTable = (
      <BuildingFloorsDisplay
        id={id}
        rooms={rooms}
        sortBy={sortBy}
        sortDirection={sortDirection}
      />
    );
  }

  return (
    <>
      <Collapse in={expanded} timeout="auto">
        <Collapse in={toolsExpanded} timeout="auto">
          {/* <TableTools data={data}/> */}
        </Collapse>
        {!!rooms.length && dataTable}
        {!loading && !rooms.length && <NoResult data={data} />}
      </Collapse>
    </>
  );
}

function NoResult({ data }) {
  const dispatch = useDispatch();

  dispatch(actionAppBarFloorsInSearchUpdated([]));
  dispatch(
    actionDataSelectFeatureRequested({
      type: "room",
      data: [],
      layerId: data.colorLayerId,
    }),
  );

  return (
    <CardActions disableSpacing sx={cardActionRoot_}>
      <Grid container align="center" justifyContent="center">
        No Result
      </Grid>
    </CardActions>
  );
}
